// The released code is licensed under the MIT license.

// Copyright (c) Themesberg (Bergside Inc.)

// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import './index.css';
import MainPage from './MainPage'
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MantineProvider } from '@mantine/core';

const cssVariablesResolver = () => ({
  variables: {},
  light: {
    '--app-surface': '#ffffff',
    '--app-surface-hover': '#f9fafb',
    '--app-surface-dim': '#f1f3f5',
    '--app-border': 'rgba(0, 0, 0, 0.08)',
    '--app-text-secondary': '#868e96',
    '--app-unread-bg': 'rgba(59, 130, 246, 0.08)',
  },
  dark: {
    '--app-surface': '#25262b',
    '--app-surface-hover': '#2c2e33',
    '--app-surface-dim': '#1a1b1e',
    '--app-border': 'rgba(255, 255, 255, 0.1)',
    '--app-text-secondary': '#909296',
    '--app-unread-bg': 'rgba(59, 130, 246, 0.15)',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="304283241995-ghd1nlennu8fhcn34st7s9q2djedena8.apps.googleusercontent.com">
    <MantineProvider
      defaultColorScheme="auto"
      cssVariablesResolver={cssVariablesResolver}
      theme={{
        fontFamily: "'IBM Plex Sans', system-ui, -apple-system, sans-serif",
        headings: { fontFamily: "'Fraunces', 'IBM Plex Sans', serif" },
        primaryColor: "blue",
        defaultRadius: "md"
      }}
    >
      <React.StrictMode>
        <MainPage />
      </React.StrictMode>
    </MantineProvider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
